import type { TileState } from '../components/WordleGrid';

export function getTileBackgroundClasses(state: TileState): string {
  switch (state) {
    case 'correct':
      return 'bg-[var(--color-game-letter-correct)]';
    case 'present':
      return 'bg-[var(--color-game-letter-present)]';
    case 'absent':
      return 'bg-[var(--color-game-letter-absent)]';
    case 'default':
    default:
      return 'bg-transparent';
  }
}

export function getTileBorderClasses(state: TileState): string {
  if (state === 'default') {
    return 'border-[var(--semantic-border-default)]';
  }
  
  switch (state) {
    case 'correct':
      return 'border-[var(--color-game-letter-correct)]';
    case 'present':
      return 'border-[var(--color-game-letter-present)]';
    case 'absent':
      return 'border-[var(--color-game-letter-absent)]';
    default:
      return 'border-[var(--color-game-border-primary)]';
  }
}

export function getTileTextClasses(state: TileState): string {
  return 'text-[var(--color-game-text-inverse)]';
}

